import type * as React from 'react';
import { get } from '@Domain/Api';
import auditResourceTypesFetched, {
	type AuditResourceTypesFetchedAction,
	type AuditResourceTypesFetchedPayload,
} from '@Application/AuditTrail/Actions/auditResourceTypesFetched';
import auditResourceTypesFetchFailed, {
	type AuditResourceTypesFetchFailedAction,
} from '@Application/AuditTrail/Actions/auditResourceTypesFetchFailed';
import type FetchAuditResourceTypes from '@Application/AuditTrail/Queries/FetchAuditResourceTypes';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AuditResourceTypesFetchedAction | AuditResourceTypesFetchFailedAction;

/** A referential list of resource types: no tenant, no parameter. */
export default (_query: FetchAuditResourceTypes) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AuditResourceTypesFetchedPayload>(
				`${parameters.api.host}/api/enums/audit-resource-types`,
			);

			const action = auditResourceTypesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = auditResourceTypesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
